module.exports = __webpack_public_path__ + "img/Chevron-Down_16px_Icon-Dark.7d3a498a.svg";